import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';
import {isString} from 'lodash';
import {Reservation} from '../../models/reservation';
import {Material} from '../models/material';
import {DomSanitizer, SafeStyle} from '@angular/platform-browser';

@Component({
  selector: 'app-material-image',
  templateUrl: './material-image.component.html',
  styleUrls: ['./material-image.component.scss']
})
export class MaterialImageComponent implements OnChanges {

  @Input()
  padding: boolean;

  @Input()
  state: Reservation['state'];

  @Input()
  type: Reservation['recordType'];

  @Input()
  src: string;

  srcUrl: SafeStyle;
  typeIconName: string;
  stateIconName: string;

  constructor(private sanitizer: DomSanitizer) {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.type) {
      this.typeIconName = this.getMaterialTypeIcon(this.type);
    }

    if (changes.state) {
      this.stateIconName = this.getStateIcon(this.state);
    }

    if (changes.src) {
      this.srcUrl = this.sanitizer.bypassSecurityTrustStyle(`url('${this.src}')`);
    }
  }

  /**
   * Gets the icon name for a material type
   * @param type
   * @returns {string|string}
   */
  private getMaterialTypeIcon(type: Reservation['recordType']): string {
    const map = {
      a: 'material-types/text',
      b: 'material-types/text',
      p: 'material-types/text',

      c: 'material-types/music',
      d: 'material-types/music',
      r: 'material-types/music',
      s: 'material-types/music',

      m: 'material-types/video',

      g: 'material-types/image',

      v: 'material-types/composite-materials',

      t: 'material-types/electronic',

      e: 'material-types/map',
      f: 'material-types/map',

      u: 'material-types/object'
    };

    return map[type] || 'material-types/object';
  }

  private getStateIcon(state: Reservation['state']): string {
    if (!isString(state)) {
      return;
    }

    const key = state.toLowerCase() as Reservation['state'] | Material['localState'];

    const map = {
      found: 'material-states/found',
      'not found': 'material-states/not-found',
      skip: 'material-states/skipped',
      lost: 'material-states/lost'
    };

    return map[key];
  }
}



// WEBPACK FOOTER //
// ./src/app/material/material-image/material-image.component.ts